import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateTeacherForm from "../../forms/CreateOrUpdateTeacherForm";
import { TeacherResponseDto } from "../../shared/dtos/teacher/TeacherResponseDto";

interface UpdateTeacherModalProps {
  open: boolean;
  onClose: () => void;
  teacher: TeacherResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateTeacherModal: React.FC<UpdateTeacherModalProps> = ({
  open,
  onClose,
  teacher,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit Teacher: ${teacher.firstName || ""}`}
    width="md"
    loading={loading}
  >
    <CreateOrUpdateTeacherForm
      isEditing={true}
      teacher={teacher}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateTeacherModal;
